import InputMask from "react-input-mask";
import {
  FIELD_ERROR_TEXT_CLASS,
  FIELD_LABEL_CLASS,
  getErrorMessage,
  getFieldClass,
} from "./inputStyles";

const PhoneInput = ({
  className,
  label,
  required,
  error,
  name,
  value,
  type = "text",
  mask = "(99) 99999-9999",
  register,
  ...props
}) => {
  const errorMessage = getErrorMessage(error);

  return (
    <div className={`w-full ${className || ""}`}>
      {label ? (
        <label className={FIELD_LABEL_CLASS} htmlFor={name}>
          {label}
        </label>
      ) : null}
      <InputMask
        type={type}
        id={name}
        className={getFieldClass(Boolean(error))}
        placeholder="(00) 00000-0000"
        {...(register && name ? register(name, { required }) : {})}
        // O react-input-mask chama .split() no `value` dentro do
        // componentDidUpdate, então null quebra a tela inteira — e o backend
        // devolve null para campo vazio. O spread é condicional de propósito:
        // passar `value` sempre tornaria controlado também quem só usa
        // `register`, e aí o campo pararia de aceitar digitação.
        {...(value !== undefined ? { value: value ?? "" } : {})}
        mask={mask}
        // Sem isto, o maskChar padrão é "_": um telefone digitado pela metade
        // é enviado como "(15) 9980_-____" e um campo vazio que só recebeu
        // foco vira "(__) _____-____" no banco.
        maskChar=""
        {...props}
      />
      {errorMessage ? (
        <small className={FIELD_ERROR_TEXT_CLASS}>{errorMessage}</small>
      ) : null}
    </div>
  );
};

export default PhoneInput;
